// @module Eureka.MaxaPartPicker.MaxaPartPicker
define('Eureka.MaxaPartPicker.MaxaPartPicker.View'
    , [
        'eureka_maxapartpicker_maxapartpicker.tpl'

        , 'Eureka.MaxaPartPicker.MaxaPartPicker.SS2Model'
        , 'Eureka.MaxaPartPicker.MaxaPartPicker.Model'

        , 'Backbone'
    ]
    , function (
        eureka_maxapartpicker_maxapartpicker_tpl
        , MaxaPartPickerSS2Model
        , MaxaPartPickerModel
        , Backbone
    ) {
        'use strict';

        // @class Eureka.MaxaPartPicker.MaxaPartPicker.View @extends Backbone.View
        return Backbone.View.extend({

            template: eureka_maxapartpicker_maxapartpicker_tpl

            , initialize: function (options) {
                //Get the hash value. This will be set if we have already searched on the PP
                var hash = window.location.hash.substr(1);
                var hashSplit = hash.split('&').reduce(function (res, item) {
                    var parts = item.split('=');
                    res[parts[0]] = parts[1];
                    return res;
                }, {});
                this.model = new MaxaPartPickerModel();
                var self = this;
                if(hashSplit.type) {
                    //If the type is in the hash it means we have already searched so we need to get all the values for all the dropdowns
                    this.model.getAll(hashSplit.type, hashSplit.brand).done(function (result) {
                        var typeArray = []
                        var types = result.types
                        var brands = result.brands
                        var models = result.models
                        console.log("models", models)
                        for (var i = 0; i < types.length; i++) {
                            //Creates the object for the types dropdown
                            if (types[i] !== null) {
                                var newObject = {}
                                newObject.name = types[i]
                                newObject.id = i
                                typeArray.push(newObject)
                            }
                        }
                        self.selectedType = hashSplit.type
                        self.types = typeArray
                        for (var j = 0; j < result.brands.length; j++) {
                            if (result.brands[j] === null) {
                                brands.splice(j, 1)
                            }
                        }
                        self.brands = brands

                        for (var k = 0; k < result.models.length; k++) {
                            if (result.models[k] === null) {
                                models.splice(k, 1)
                            }
                        }
                        //Sets all the values to be set on the dropdowns
                        self.types = typeArray
                        self.brands = brands
                        self.models = models
                        self.selectedType = hashSplit.type
                        self.selectedBrand = hashSplit.brand
                        self.selectedModel = hashSplit.model
                        self.render();
                    })
                }else {
                    //This will get a list of all the types
                    this.model.fetch().done(function (result) {
                        self.types = result
                        self.render();
                    });
                }
            }

            , events: {
                'change [data-action="type-select"]': 'typeSelect',
                'change [data-action="brand-select"]': 'brandSelect',
                'change [data-action="model-select"]': 'modelSelect',
                'click [data-action="search-records"]': 'saveCustomForm'
            }

            , bindings: {}

            , childViews: {}

            , typeSelect: function (e) {
                var self = this
                self.brands = {}
                //Get all the brands that have a PP record linked to the Type
                this.model.findBrands(e.target.value).done(function (result) {
                    var resultArray = result
                    for (var i = 0; i < result.length; i++) {
                        if (result[i] === null) {
                            resultArray.splice(i, 1)
                        }
                    }
                    self.brands = resultArray
                    self.selectedType = e.target.value
                    self.selectedBrand = false
                    self.selectedModel = false
                    self.render()
                })
            }

			, brandSelect: function (e) {
				var self = this
                self.models = {}
                //Get all the models that have a PP record linked to the Type and Brand selected
                this.model.findModels(e.target.value, self.selectedType).done(function (result) {
                    //console.log(result)
                    var resultArray = result
                    for (var i = 0; i < result.length; i++) {
                        if (result[i] === null) {
                            resultArray.splice(i, 1)
                        }
                    }
                    self.models = resultArray
                    self.selectedBrand = e.target.value
                    self.render()
				})

			}
            , modelSelect: function (e) {
                var self = this
                self.selectedType = this.selectedType
                self.brands = this.brands
                self.selectedBrand = this.selectedBrand
                self.selectedModel = e.target.value
                self.render()
            }

            , saveCustomForm: function (e) {
                //Will redirect to the parts picker page MaxaPartPickerMain.View.js
              window.location.href = `/partspicker#type=${this.selectedType}&brand=${this.selectedBrand}&model=${this.selectedModel}`
            }

            //@method getContext @return Eureka.MaxaPartPicker.MaxaPartPicker.View.Context
            , getContext: function getContext() {
				var disableBrand = true
                var disableModel = true
                if (this.selectedType) {
                    //If we have a type the brand should not be disabled
					disableBrand = false
                    for (var i = 0; i < this.types.length; i++) {
                        //Find the selected type and set this so we can set it in the HTML
                        if (Number(this.selectedType) === Number(this.types[i].id)) {
                            this.types[i].selected = true
                        }else{
                            if(this.types[i].selected === true) {
                                this.types[i].selected = false
                            }
                        }
                    }
                    if(this.selectedBrand){
                        //If we have a selected brand then Model should not be disabled
                        disableModel = false
                        for (var j = 0; j < this.brands.length; j++) {
                            if(this.brands[j] !== null) {
                                if (Number(this.selectedBrand) === Number(this.brands[j].id)) {
                                    this.brands[j].selected = true
                                } else {
                                    if (this.brands[j].selected === true) {
                                        this.brands[j].selected = false
                                    }
                                }
                            }
                        }
                    }
                    console.log("this.selectedModel", {selected: this.selectedModel, models: this.models})
                    if(this.models){
                        for(var k = 0; k < this.models.length; k++) {
                            if(this.models[k] !== null) {
                                if (Number(this.selectedModel) === Number(this.models[k].id)) {
                                    this.models[k].selected = true
                                } else {
                                    if (this.models[k].selected === true) {
                                        this.models[k].selected = false
                                    }
                                }
                            }
                        }
                    }

                }

                return {
                    types: this.types,
                    selectedType: this.selectedType,
                    brands: this.brands,
                    selectedBrand: this.selectedBrand,
                    models: this.models,
					disableBrand: disableBrand,
                    disableModel: disableModel,
                    buttonDisabled: !(this.selectedType && this.selectedBrand && this.selectedModel)
                };
            }
        });
    });
